import { motion } from 'framer-motion'
import React from 'react'

const HomePageLoader = () => {

    const products = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]

    return (
        <motion.div className="relative h-full w-full">
            <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 xl:grid-cols-4 gap-10 lg:grid-cols-4">
                {
                    products && products.map((pro, i) => {
                        return <motion.div key={i} className="relative h-80 w-72 flex flex-col bg-white drop-shadow-lg">
                            <motion.div className="absolute top-5 right-5 text-xl"><motion.div className="h-9 w-9 bg-slate-200 animate pulse" /></motion.div>
                            <motion.div className="px-2 py-2 h-60 bg-slate-200 animate pulse flex flex-row justify-center"></motion.div>
                            <motion.div className="px-2 my-2 flex-row flex items-center font-bold text-xl">
                                <motion.div className="w-20 h-9 rounded-full animate pulse bg-slate-200"></motion.div>
                            </motion.div>
                            <motion.div className="px-2 my-2 flex flex-row  text-primeColor/40">
                                <motion.div className="w-40 h-2 rounded-full animate pulse bg-slate-200"></motion.div>
                            </motion.div>
                        </motion.div>
                    })
                }
            </motion.div>
        </motion.div>
    )
}

export default HomePageLoader